import React, { createContext, useContext, useState, ReactNode } from "react";

/** Um total do resumo do relatorio, ja formatado para exibicao. */
export interface IResumoItem {
  label: string;
  valor: string;
}

/** O que o cabecalho mostra no lugar do titulo quando o resumo se recolhe. */
export interface IResumoHeader {
  totais: IResumoItem[];
  /** Conteudo do dropdown de graficos, que sobe junto com os totais. */
  graficos: ReactNode;
}

interface ReportContextType {
  isGeneratingReport: boolean;
  setIsGeneratingReport: (value: boolean) => void;
  /**
   * Totais que o cabecalho deve mostrar no lugar do titulo. O card de resumo
   * publica aqui quando rola para fora da tela, e limpa ao sair da pagina - o
   * cabecalho vive no Layout, fora da arvore do relatorio, entao o contexto e o
   * unico caminho entre os dois.
   */
  resumoHeader: IResumoHeader | null;
  setResumoHeader: (value: IResumoHeader | null) => void;
}

const ReportContext = createContext<ReportContextType | undefined>(undefined);

export const ReportProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [isGeneratingReport, setIsGeneratingReport] = useState(false);
  const [resumoHeader, setResumoHeader] = useState<IResumoHeader | null>(null);

  return (
    <ReportContext.Provider value={{ isGeneratingReport, setIsGeneratingReport, resumoHeader, setResumoHeader }}>
      {children}
    </ReportContext.Provider>
  );
};

export const useReportContext = () => {
  const context = useContext(ReportContext);
  if (!context) throw new Error("useReportContext must be used within ReportProvider");
  return context;
};